import { useI18n } from '@change-corgi/core-react/i18n';

import { useDecisionMakerResponsePageData } from '#src/app/pages/decisionMaker/response/details/pageContext';

type Result = ModelHookResult<{
	title: string;
	type: string;
	petitionTitle: string;
	petitionUrl: string;
	pageError?: string;
}>;

export function usePageHeading(): Result {
	const {
		data: {
			decisionMakerResponse: { decisionMaker, petition },
		},
	} = useDecisionMakerResponsePageData();
	const { translate } = useI18n();

	return {
		data: {
			title: translate('fe.components.updates_feed.decision_maker_title', { name: decisionMaker.displayName }),
			type: translate('fe.pages.decision_maker_response.title'),
			petitionTitle: petition.ask,
			petitionUrl: `/p/${encodeURIComponent(petition.slug)}`,
		},
	};
}
